import React from "react";
import Layout from "../../Layout";
import { patientTab } from "../../components/Datas";
import { Link, useParams } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";
import MedicalRecord from "./MedicalRecord";
import AppointmentsUsed from "../../components/UsedComp/AppointmentsUsed";
import InvoiceUsed from "../../components/UsedComp/InvoiceUsed";
import PaymentsUsed from "../../components/UsedComp/PaymentUsed";
import PersonalInfo from "../../components/UsedComp/PersonalInfo";
import PatientImages from "./PatientImages";
import Vitals from "./HealthInfomation";
import DentalChart from "./DentalChart";
import { PatientChat } from "./PatientChat";
import { BiPlus } from "react-icons/bi";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl";
import { toast } from "react-hot-toast";

function PatientProfile() {
  const { id } = useParams();
  const [activeTab, setActiveTab] = React.useState(1);
  const [isMRMO, setIsMRMO] = React.useState(false); // isMedicalRecordModalOpen
  const [patient, setPatient] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  // Fetch patient data
  React.useEffect(() => {
    const fetchPatient = async () => {
      if (!id) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get(`${BaseUrl}/doctor/patient/${id}`, {
          withCredentials: true,
        });

        if (response.data) {
          setPatient(response.data);
        }
      } catch (error) {
        console.error("Error fetching patient:", error);
        toast.error(error.response?.data?.message || "Failed to load patient data");
      } finally {
        setLoading(false);
      }
    };

    fetchPatient();
  }, [id]);

  const tabPanel = () => {
    if (!id) {
      return (
        <div className='flex items-center justify-center py-10'>
          <p className='text-textGray'>Invalid patient ID</p>
        </div>
      );
    }

    switch (activeTab) {
      case 1:
        return <MedicalRecord isMRMO={isMRMO} setIsMRMO={setIsMRMO} patientId={id} />;
      case 2:
        return <PersonalInfo titles={false} patientId={id} patient={patient} />;
      case 3:
        return <AppointmentsUsed doctor={false} patientId={id} />;
      case 4:
        return <PatientImages patientId={id} />;
      case 5:
        return <Vitals patientId={id} />;
      case 6:
        return <InvoiceUsed patientId={id} />;
      case 7:
        return <PaymentsUsed doctor={false} patientId={id} />;
      case 8:
        return <PatientChat patientId={id} />;
      default:
        return;
    }
  };

  // Get patient display info
  const patientName = patient?.fullName || patient?.title || "Loading...";
  const patientEmail = patient?.email || patient?.emailId || "";
  const patientPhone = patient?.mobileNumber || patient?.phone || "";
  const patientImage = patient?.userImage || patient?.profileImage || patient?.image || "/images/user7.png";

  if (loading) {
    return (
      <Layout>
        <div className='flex items-center justify-center py-20'>
          <p className='text-textGray'>Loading patient data...</p>
        </div>
      </Layout>
    );
  }

  if (!patient && !loading) {
    return (
      <Layout>
        <div className='flex items-center gap-4'>
          <Link
            to='/patients'
            className='text-md rounded-lg border border-dashed border-subMain bg-white px-4 py-3'
          >
            <IoArrowBackOutline />
          </Link>
        </div>
        <div className='flex items-center justify-center py-20'>
          <p className='text-textGray'>Patient not found</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className='flex items-center gap-4'>
        <Link
          to='/patients'
          className='text-md rounded-lg border border-dashed border-subMain bg-white px-4 py-3'
        >
          <IoArrowBackOutline />
        </Link>
        <h1 className='text-xl font-semibold'>{patientName}</h1>
      </div>

      {/* {
        activeTab === 1 && isMRMO && (
          <MedicalRecord isMRMO={isMRMO} setIsMRMO={setIsMRMO} />
        )
      } */}
      <div className='my-8 grid grid-cols-12 items-start gap-6'>

        {activeTab === 1 &&
          (<div
            onClick={() => {
              console.log("Eder to paka aya ");
              setIsMRMO(true)

            }}
            className='flex-colo button-fb fixed bottom-8 right-12 z-50 h-16 w-16 animate-bounce rounded-full border border-border bg-[#0095D9] cursor-pointer text-white'
          >
            <BiPlus className='text-2xl' />
          </div>
          )}

        <div
          data-aos='fade-right'
          data-aos-duration='1000'
          data-aos-delay='100'
          data-aos-offset='200'
          className='flex-colo top-28 col-span-12 gap-6 rounded-xl border-[1px] border-border bg-white p-6 lg:sticky lg:col-span-4'
        >
          <div className={`${activeTab === 2 ? "bg-text" : ""} border-dashed border-text hover:bg-text rounded-lg cursor-pointer px-5 p-3`} onClick={(() => setActiveTab(2))}>
            <img
              src={patientImage}
              alt={patientName}
              className='h-40 w-40 rounded-full border border-dashed border-subMain object-cover'
              onError={(e) => {
                e.target.src = `https://api.dicebear.com/5.x/initials/svg?seed=${patientName}`;
              }}
            />
            <div className='flex-colo gap-2'>
              <h2 className='text-sm font-semibold'>{patientName}</h2>
              {patientEmail && <p className='text-xs text-textGray'>{patientEmail}</p>}
              {patientPhone && <p className='text-xs'>{patientPhone}</p>}
            </div>

          </div>
          {/* tabs */}
          <div className='flex-colo w-full gap-3 px-2 xl:px-12'>
            {patientTab.map((tab, index) => (
              <button
                onClick={() => setActiveTab(tab.id)}
                key={index}
                className={` ${activeTab === tab.id
                  ? "bg-text text-subMain"
                  : "bg-dry text-main hover:bg-text hover:text-subMain"
                  } flex w-full items-center gap-4 rounded p-4 text-xs`}
              >
                <tab.icon className='text-lg' /> {tab.title}
              </button>
            ))}
          </div>
        </div>
        {/* tab panel */}
        <div
          data-aos='fade-left'
          data-aos-duration='1000'
          data-aos-delay='100'
          data-aos-offset='200'
          className='col-span-12 rounded-xl border-[1px] border-border bg-white p-6 lg:col-span-8'
        >
          {tabPanel()}
        </div>
      </div>
    </Layout>
  );
}

export default PatientProfile;
